import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
// material
import {
  Card,
  Checkbox,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableRow,
  Tabs,
  Tab,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Tooltip,
  styled
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
// components
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
import { fDate, fDateNew } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import PayoutToolbar from './PayoutToolbar';
import { getPayoutList } from '../../store/Slice/Payout/PayoutSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { isValidValue, normalizeValue } from '../../utils/CommonFunction';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';
import {
  downloadApiData,
  getMasterListType,
  saveApiData
} from '../../store/Slice/Global/GlobalSlice';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';
import BrudCrumbs from '../../components/BreadCrumbs';
import { PayoutApi } from '../../utils/Apis';
import { setApiError, setApiSuccess } from '../../store/Slice/Error/ErrorSlice';
import Summary from './Summary';
import Network from './Network';
import PandL from './PandL';
import Profile from './Profile';
import { pillTabsSx } from '../Global/Styling';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    fontWeight: '700',
    padding: '12px 10px',
    color: '#637381',
    textTransform: 'uppercase',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 10px',
    borderBottom: '1px solid #f4f6f8'
  }
}));

const TABLE_HEAD = [
  { id: 'leadId', label: 'Application Id', alignRight: false },
  { id: 'lanId', label: 'File No.', alignRight: false },
  { id: 'created', label: 'Submission Date', alignRight: false },
  { id: 'bankName', label: 'Bank Name', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'name', label: 'Borrower Name', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'monthName', label: 'Disb Date', alignRight: false },
  { id: 'amount2', label: 'Disbursed Amount', alignRight: false },
  { id: 'sourceFlag', label: 'File Source', alignRight: false },
  { id: 'partnerName', label: 'Partner', alignRight: false },
  { id: 'payoutStatus', label: 'Status', alignRight: false },
  { id: 'lastUpdated', label: 'Last update', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

export default function PayoutList() {
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState();
  const [filterName, setFilterName] = useState('');
  const [order, setOrder] = useState('desc');
  const [page1, setPage1] = useState(1);
  const [selectStatus, setSelectStatus] = useState(' ');
  const [filterParameter, setFilterParameter] = useState({
    bankId: null,
    bankName: null,
    cityId: null,
    loanTypeId: null
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [RaiseAdavance, setRaiseAdvance] = useState(false);
  const [raiseAdvanceData, setRaiseAdvanceData] = useState(null);

  const [advanceFormData, setAdvanceFormData] = useState({
    advanceAmount: '',
    purpose: ''
  });

  const [isSubmittingAdvance, setIsSubmittingAdvance] = useState(false);

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { PayoutListData } = usePayoutSelector();
  const debouncedSearch = useDebounce(filterName, 600);

  // console.log('PayoutListData List Data', PayoutListData);
  // console.log('raiseAdvanceData List Data', raiseAdvanceData);
  // console.log('selected Data', selected);
  const navigate = useNavigate();

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = PayoutListData?.map((n) => n?.partnerPayoutId);
      // console.log('newSelecteds', newSelecteds);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - PayoutListData.length) : 0;

  const handleClick = (event, name) => {
    // Extract the ID from the item object
    const itemId = name?.partnerPayoutId || name;
    // console.log('selected item', itemId);
    const selectedIndex = selected.indexOf(itemId);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, itemId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  // Master Type List
  const getMasterTypeListApi = () => {
    const type = 'PAYOUT_STATUS_TYPE';
    dispatch(getMasterListType(type));
  };

  const getPayoutListApi = useCallback(() => {
    // alert('Get Payout List Api called');
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        sortOrder: order
      },
      filterModel: {
        // bankId: filterParameter?.bankId || null,
        bankId: filterParameter?.bankId || null,
        cityId: filterParameter?.cityId || null,
        loanTypeId: filterParameter?.loanTypeId || null
      },
      filterPayoutStatusId: isValidValue(selectStatus) ? selectStatus : null
    };
    dispatch(getPayoutList(credentials));
  }, [
    LoginData,
    page1,
    rowsPerPage,
    debouncedSearch,
    order,
    selectStatus,
    filterParameter,
    dispatch,
    page
  ]);

  useEffect(() => {
    getPayoutListApi();
  }, [getPayoutListApi]);

  useEffect(() => {
    getMasterTypeListApi();
  }, []);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  useEffect(() => {
    if (!PayoutListData) {
      setHasNextPage(true);
      return;
    }
    // If API returned fewer rows → last page
    setHasNextPage(PayoutListData.length >= rowsPerPage);
  }, [PayoutListData, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  const handleRaiseAdvanceRequest = useCallback((rowId) => {
    // console.log('Raise Advance Request for row:', rowId);
    setRaiseAdvanceData(rowId);
    setRaiseAdvance(true);
    // Implement the logic to raise an advance request here
  }, []);

  const RaiseAdvanceRequestOperation = useCallback(async () => {
    // Validate inputs
    if (!advanceFormData.advanceAmount || !advanceFormData.purpose) {
      dispatch(setApiError('Please fill all required fields'));
      return;
    }

    const amount = Number(advanceFormData.advanceAmount);

    if (Number.isNaN(amount) || amount <= 0) {
      dispatch(setApiError('Please enter a valid advance amount'));
      return;
    }

    setIsSubmittingAdvance(true);
    const finalData = {
      partnerId: raiseAdvanceData?.partnerId,
      payoutId: raiseAdvanceData?.partnerPayoutId || null,
      requestAmount: parseInt(advanceFormData.advanceAmount, 10),
      purpose: advanceFormData.purpose,
      userId: LoginData?.userId
    };

    try {
      const res = await dispatch(saveApiData(PayoutApi?.raiseAdavancePayout, finalData));

      // console.log('Response from raise advance payout API:', res);

      if (!res) return;
      if (res?.requestDate) {
        // Reset form
        setAdvanceFormData({ advanceAmount: '', purpose: '' });
        setRaiseAdvance(false);
        // Refresh the payout list
        getPayoutListApi();
        dispatch(setApiSuccess('Advance request submitted successfully!'));
      } else {
        dispatch(setApiError(res?.payload?.message || 'Failed to submit advance request'));
      }
    } catch (error) {
      console.error('Error submitting advance request:', error);
      dispatch(setApiError('Error submitting advance request. Please try again.'));
    } finally {
      setIsSubmittingAdvance(false);
    }
  }, [advanceFormData, raiseAdvanceData, LoginData, dispatch, getPayoutListApi]);

  const handleDownload = async (type) => {
    const credentials = {
      userId: LoginData?.userId,
      companyId: LoginData?.companyId,
      selectedPayoutIds: selected,
      filters: {
        bankId: filterParameter?.bankId,
        cityId: filterParameter?.cityName,
        loanTypeId: filterParameter?.loanTypeName
      }
    };

    try {
      const result = await dispatch(downloadApiData(PayoutApi?.payoutDownload, credentials));

      if (result?.success && result?.data) {
        const fileName = `PayoutDataDownload_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}.xlsx`;

        const url = window.URL.createObjectURL(result.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Download failed:', result.error);
      }
    } catch (error) {
      console.error('Export error:', error);
    }
  };
  return (
    <Page title="Partner Management System || Payout">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Payout" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>{' '}
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="payout tabs"
            sx={{ ...pillTabsSx, mb: 2.5 }}
          >
            <Tab
              icon={<SwapHorizIcon />}
              iconPosition="start"
              label="Payout List"
              {...a11yProps(0)}
            />
            <Tab icon={<AssessmentIcon />} iconPosition="start" label="Summary" {...a11yProps(1)} />
            <Tab icon={<TrendingUpIcon />} iconPosition="start" label="P&L" {...a11yProps(2)} />
            <Tab icon={<PeopleIcon />} iconPosition="start" label="Network" {...a11yProps(3)} />
            <Tab icon={<PersonIcon />} iconPosition="start" label="Profile" {...a11yProps(4)} />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <Card
              sx={{
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                border: '1px solid #e2e8f0',
                overflow: 'hidden'
              }}
            >
              <PayoutToolbar
                parent="payout"
                selectStatus={selectStatus}
                setSelectStatus={setSelectStatus}
                onFilterName={handleFilterByName}
                setFilterParameter={setFilterParameter}
                filterParameter={filterParameter}
                filterName={filterName}
                handleDownload={handleDownload}
              />
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800, minHeight: 380, overflow: 'auto' }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={PayoutListData?.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      isCheckBox="true"
                    />
                    <TableBody>
                      {PayoutListData?.length > 0 &&
                        PayoutListData?.map((item, index) => {
                          const isItemSelected = selected.indexOf(item?.partnerPayoutId) !== -1;

                          return (
                            <TableRow
                              hover
                              key={item?.partnerPayoutId || index}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                              sx={{
                                '&:nth-of-type(even)': { backgroundColor: '#fafbfc' },
                                '&.Mui-selected, &.Mui-selected:hover': {
                                  backgroundColor: 'rgba(19, 81, 157, 0.08)'
                                }
                              }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, item)}
                                  sx={{
                                    color: '#94a3b8',
                                    '&.Mui-checked': { color: '#13519d' }
                                  }}
                                />
                              </TableCell>
                              <StyledTableCell
                                align="left"
                                sx={{ fontWeight: 600, color: '#13519d' }}
                              >
                                {normalizeValue(item?.partnerPayoutId, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                sx={{ fontWeight: 600, color: '#13519d' }}
                              >
                                {normalizeValue(item?.fileNumber, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {isValidValue(item?.fileSubmissionDate)
                                  ? fDate(item?.fileSubmissionDate)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.bankName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.cityName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.borrowerName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.loanTypeName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(
                                  fDateNew(item?.disburseDate || item?.disburseMonth),
                                  NOT_AVAILABLE
                                )}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.disburseAmount, NOT_AVAILABLE)}
                                {item?.payoutStatus === 'Matched' && (
                                  <Tooltip
                                    title={item?.revenueDisbursedAmount}
                                    placement="left"
                                    arrow
                                  >
                                    <IconButton
                                      size="small"
                                      sx={{
                                        p: 0.5,
                                        ml: 0.5,
                                        color: '#13519d',
                                        bgcolor: 'rgba(19, 81, 157, 0.08)',
                                        '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                                      }}
                                    >
                                      <InfoOutlinedIcon sx={{ fontSize: 14 }} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    item?.sourceFlag === 'LOGIN_FILE' ||
                                    item?.logInStatusName === 'Rejected'
                                      ? 'warning'
                                      : 'primary'
                                  }
                                >
                                  {normalizeValue(item?.sourceFlag, NOT_AVAILABLE)}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.partnerName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Not Matched' &&
                                      'error') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'MIS' &&
                                      'warning') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Invoice' &&
                                      'warning') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Payment Due' &&
                                      'error') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Paid' &&
                                      'success') ||
                                    'success'
                                  }
                                >
                                  {item?.payoutStatus ? item?.payoutStatus : `${NOT_AVAILABLE}`}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {isValidValue(item?.lastUpdated)
                                  ? fDate(item?.lastUpdated)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>

                              <StyledTableCell align="center" width={80}>
                                <UserMoreMenu
                                  rowId={item}
                                  parent="payout"
                                  handleRaiseAdvanceRequest={handleRaiseAdvanceRequest}
                                />
                              </StyledTableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                    {PayoutListData?.length === 0 && (
                      <TableBody>
                        <TableRow>
                          <StyledTableCell
                            align="center"
                            colSpan={TABLE_HEAD.length + 1}
                            sx={{ py: 6 }}
                          >
                            <SearchNotFound searchQuery={filterName} />
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
              <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Summary />
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <Card
              sx={{
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                border: '1px solid #e2e8f0',
                overflow: 'hidden'
              }}
            >
              <PandL />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <Card
              sx={{
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                border: '1px solid #e2e8f0',
                overflow: 'hidden'
              }}
            >
              <Network />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={4}>
            <Profile />
          </TabPanel>
        </Box>

        {/* Raise Advance Request Dialog */}
        <Dialog
          open={RaiseAdavance}
          fullWidth
          maxWidth="sm"
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              py: 2
            }}
          >
            <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 700, color: '#1e293b' }}>
              Raise Advance Request
            </Typography>
            <IconButton
              onClick={() => {
                setRaiseAdvance(false);
                setAdvanceFormData({ advanceAmount: '', purpose: '' });
              }}
              size="small"
              sx={{ color: '#64748b' }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            <Grid container spacing={2.5} sx={{ mt: 0.5 }}>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#64748b', mb: 0.8 }}>
                  File No.
                </Typography>
                <TextField
                  value={raiseAdvanceData?.fileNumber || ''}
                  type="text"
                  variant="outlined"
                  disabled
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      bgcolor: '#f1f5f9'
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#64748b', mb: 0.8 }}>
                  Bank Name
                </Typography>
                <TextField
                  value={raiseAdvanceData?.bankName || ''}
                  type="text"
                  variant="outlined"
                  disabled
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      bgcolor: '#f1f5f9'
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#64748b', mb: 0.8 }}>
                  Borrower Name
                </Typography>
                <TextField
                  value={raiseAdvanceData?.borrowerName || ''}
                  type="text"
                  variant="outlined"
                  disabled
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      bgcolor: '#f1f5f9'
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#64748b', mb: 0.8 }}>
                  Disburse Amount
                </Typography>
                <TextField
                  value={raiseAdvanceData?.disburseAmount || ''}
                  type="text"
                  variant="outlined"
                  disabled
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      bgcolor: '#f1f5f9'
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#1e293b', mb: 0.8 }}>
                  Advance Amount *
                </Typography>
                <TextField
                  value={advanceFormData.advanceAmount}
                  onChange={(e) =>
                    setAdvanceFormData({ ...advanceFormData, advanceAmount: e.target.value })
                  }
                  type="number"
                  variant="outlined"
                  placeholder="Enter Advance Amount"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px'
                    }
                  }}
                  inputProps={{ min: '0', step: '1' }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#1e293b', mb: 0.8 }}>
                  Purpose *
                </Typography>
                <TextField
                  value={advanceFormData.purpose}
                  onChange={(e) =>
                    setAdvanceFormData({ ...advanceFormData, purpose: e.target.value })
                  }
                  fullWidth
                  type="text"
                  multiline
                  rows={3}
                  placeholder="Enter purpose for advance request"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px'
                    }
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 2, px: 3, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
            <Button
              onClick={() => {
                setRaiseAdvance(false);
                setAdvanceFormData({ advanceAmount: '', purpose: '' });
              }}
              sx={{ color: '#64748b', textTransform: 'none', fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              onClick={RaiseAdvanceRequestOperation}
              variant="contained"
              disabled={isSubmittingAdvance}
              sx={{
                bgcolor: '#13519d',
                '&:hover': { bgcolor: '#0d3b75' },
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '8px',
                px: 3
              }}
            >
              {isSubmittingAdvance ? 'Submitting...' : 'Submit'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
